import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { UtilService } from '@services';

import {
  fetchCustomers,
  selectCustomers,
  selectCustomersFetchedAt,
} from '@state';

@Component({
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
  ],
  templateUrl: './customers.page.html',
  styleUrl: './customers.page.scss',
})
export class CustomersPage implements OnInit {
  columns: string[] = ['image', 'name', 'status'];

  $customersFetchedAt = this.store.select(selectCustomersFetchedAt);
  $customers = this.store.select(selectCustomers);

  constructor(
    private store: Store,
    private router: Router,
    public utils: UtilService
  ) {}

  public ngOnInit(): void {
    this.store.dispatch(fetchCustomers());
  }

  public onRowClicked(id: string): void {
    this.router.navigate([`/customers/${id}`]);
  }
}
